module.exports = __webpack_public_path__ + "media/images/btn-cart-03ad7f610ec73c6a5b77baee572af18e.svg";